import { SNAPSHOT_ROOT_FRAME } from 'dashboard/pages/Content/pages/Snapshots/constants';

const getIframeSelector = (
  iframeDocument: Document | undefined,
  selector: string,
): Element | null | undefined => {
  try {
    return iframeDocument?.querySelector(selector);
  } catch (e) {
    return undefined;
  }
};

export const getIframeRoot = () =>
  document.getElementById(SNAPSHOT_ROOT_FRAME) as HTMLIFrameElement | undefined;

export const getSelectorFromIframe = (placementSelector?: string) => {
  if (!placementSelector) {
    return null;
  }

  const snapshotRoot = getIframeRoot();
  if (!snapshotRoot) {
    return null;
  }

  const querySelector = getIframeSelector(snapshotRoot.contentWindow?.document, placementSelector);
  if (!querySelector) {
    return null;
  }

  return querySelector;
};
